export default "__VITE_ASSET__d6943056__"